import budget from "./budget.svg";
import construction from "./construction.svg";
import investment from "./investment.svg";
import inventory from "./inventory.svg";
import purchase from "./purchase.svg";
import portal from "./portal.svg";
import pmdm from "./pmdm.svg";
import usermanual from "./manual.jpg";
import asset from "./asset.png";

export const images = [
  {
    name: "budget",
    title: "Ngân sách",
    src: budget,
  },
  {
    name: "construction",
    title: "Xây dựng",
    src: construction,
  },
  {
    name: "eConstruction",
    title: "Xây dựng 2",
    src: construction,
  },
  {
    name: "investment",
    title: "Đầu tư",
    src: investment,
  },
  {
    name: "inventory",
    title: "Kho hàng",
    src: inventory,
  },
  {
    name: "purchase",
    title: "Mua hàng",
    src: purchase,
  },
  {
    name: "portal/",
    title: "Portal",
    src: portal,
  },
  {
    name: "pmdm",
    title: "Master data",
    src: pmdm,
  },
  {
    name: "portal/user-manual/user-manual-master",
    title: "User manual",
    src: usermanual,
  },
  {
    name: "asset",
    title: "Tài sản",
    src: asset,
  },
];
